import { NavLink } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import styles from './Layout.module.css'

interface SidebarProps {
  collapsed: boolean
  onToggle: () => void
}

const navItems = [
  { to: '/gaviota', icon: 'dashboard', label: 'Dashboard', end: true, roles: null },
  { to: '/gaviota/projects', icon: 'projects', label: 'Projects', roles: null },
  { to: '/gaviota/catalog', icon: 'catalog', label: 'Catalog', roles: null },
  { to: '/gaviota/quotes', icon: 'quotes', label: 'Quotes', roles: ['sales_consultant', 'management', 'partner_admin', 'keder_admin'] as string[] },
  { to: '/gaviota/orders', icon: 'orders', label: 'Orders', roles: null },
]

const iconMap: Record<string, string> = {
  dashboard: 'M4 5a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1V5zm10 0a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1V5zM4 15a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1v-4zm10 0a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z',
  projects: 'M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z',
  catalog: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10',
  quotes: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
  orders: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4',
}

export function Sidebar({ collapsed, onToggle }: SidebarProps) {
  const { profile } = useAuth()

  const visibleItems = navItems.filter(item =>
    !item.roles || (profile && item.roles.includes(profile.role))
  )

  return (
    <aside className={`${styles.sidebar} ${collapsed ? styles.sidebarCollapsed : ''}`}>
      <div className={styles.sidebarHeader}>
        <div className={styles.sidebarLogo}>
          <svg width="28" height="28" viewBox="0 0 32 32" fill="none">
            <rect width="32" height="32" rx="8" fill="#0d1b2a"/>
            <text x="16" y="22" textAnchor="middle" fill="white" fontFamily="Space Grotesk" fontWeight="700" fontSize="18">G</text>
          </svg>
          {!collapsed && <span>Gaviota</span>}
        </div>
        <button className={styles.collapseBtn} onClick={onToggle} aria-label="Toggle sidebar">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            {collapsed ? <path d="M9 18l6-6-6-6"/> : <path d="M15 18l-6-6 6-6"/>}
          </svg>
        </button>
      </div>

      <nav className={styles.sidebarNav}>
        {visibleItems.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) => `${styles.navItem} ${isActive ? styles.navItemActive : ''}`}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d={iconMap[item.icon]} />
            </svg>
            {!collapsed && <span>{item.label}</span>}
          </NavLink>
        ))}
      </nav>

      <div className={styles.sidebarFooter}>
        {profile && !collapsed && (
          <div className={styles.userInfo}>
            <div className={styles.userAvatar}>
              {(profile.full_name || profile.email).charAt(0).toUpperCase()}
            </div>
            <div className={styles.userDetails}>
              <span className={styles.userName}>{profile.full_name || 'User'}</span>
              <span className={styles.userRole}>{profile.role.replace(/_/g, ' ')}</span>
            </div>
          </div>
        )}
      </div>
    </aside>
  )
}
